// Constants for suspended reasons
export const SUSPENDED_REASONS = {
	WITHDRAWAL: 'SuspendedWithdrawal',
	DEPOSIT: 'SuspendedDeposit'
};

// Constants for operation types
export const OPERATION_TYPES = {
	DEPOSIT: 'DEPOSIT' as const,
	WITHDRAW: 'WITHDRAWAL' as const,
	BOTH: 'BOTH' as const,
	NONE: null as null
};

// Constants for UI text
export const UI_TEXT = {
	TITLES: {
		[OPERATION_TYPES.WITHDRAW]: 'SUSPENDED_POPUP_WITHDRAW_TITLE',
		[OPERATION_TYPES.DEPOSIT]: 'SUSPENDED_POPUP_DEPOSIT_TITLE'
	},
	CONTENT: {
		[OPERATION_TYPES.WITHDRAW]: 'SUSPENDED_POPUP_WITHDRAW_MESSAGE',
		[OPERATION_TYPES.DEPOSIT]: 'SUSPENDED_POPUP_DEPOSIT_MESSAGE'
	},
	BUTTON: {
		CONTACT_SUPPORT: 'SUSPENDED_POPUP_CONTACT_SUPPORT'
	}
};

// Constants for test IDs
export const TEST_IDS = {
	SUPPORT_BUTTON: 'suspended-support-button'
};

export const TEXT_KEYS = [
	'SUSPENDED_POPUP_WITHDRAW_TITLE',
	'SUSPENDED_POPUP_DEPOSIT_TITLE',
	'SUSPENDED_POPUP_WITHDRAW_MESSAGE',
	'SUSPENDED_POPUP_DEPOSIT_MESSAGE',
	'SUSPENDED_POPUP_CONTACT_SUPPORT'
];
